/**
 * Temporary End Of life Message banner for Mac OS <= 10.8 and Win XP/Vista
 * TODO: Delete this function after Apr 1, 2016. Honor up for grabs.
 */
define('banner/custom-banners/eol-message',['require','durandal/app','web-urls','i18next','mixpanel-helper'],function (require) {
    var app = require('durandal/app');
    var webUrls = require('web-urls');
    var i18n = require('i18next');
    var mixpanelHelper = require('mixpanel-helper');

    return {
        initialize: function (activeInstruction) {
            var userAgent = navigator.userAgent.toLowerCase();
            var isMac = userAgent.indexOf('mac os x 10') !== -1;
            var isWinXP = userAgent.indexOf('windows nt 5') !== -1;
            var isWin7 = userAgent.indexOf('windows nt 6.0') !== -1;
            var macVersion;

            if (isMac) {
                var regExp = /mac os x 10(?:_|\.)(\d\d?)/g;
                macVersion = parseInt(regExp.exec(userAgent)[1], 10);
            }

            // Show EOL Message Banner
            if (macVersion <= 8 || isWinXP || isWin7) {
                var versionName;
                var translatedMsg;
                if (macVersion) {
                    versionName = 'OSX v10.8';  // Used for tracking
                    translatedMsg = i18n.t('myMeetings.eolMsgBanner.mac') + ' ' +
                      i18n.t('myMeetings.eolMsgBanner.macNotice');
                } else {
                    versionName = isWinXP ? 'Win XP' : 'Win 7'; // Used for tracking
                    translatedMsg = i18n.t('myMeetings.eolMsgBanner.windows') + ' ' +
                      i18n.t('myMeetings.eolMsgBanner.windowNotice');
                }

                var msg = translatedMsg +
                  ' <a href="' + webUrls.get('eolLearnMore') + '" target="_blank" id="eol-msg-banner">' +
                  i18n.t('myMeetings.eolMsgBanner.learnMore') +
                  '</a>';
                var msgIcon = 'togo-icon-alert';
                var bannerClass = 'alert-warning';

                var macBanner = {
                    id: 'eol-msg-banner',
                    iconClasses: 'togo-icon ' + msgIcon,
                    classes: bannerClass,
                    message: msg,
                    onAddSuccess: function () {
                        // Click handler tracking EOL Msg Banner links.
                        $('#eol-msg-banner').click(function () {
                            mixpanelHelper.track('EOL Msg link clicked for ' + versionName);
                        });
                    }
                };

                if (activeInstruction && activeInstruction.config.id === 'meetings') {
                    mixpanelHelper.track('EOL message banner shown for ' + versionName);
                    app.trigger('banner:addOne', macBanner);
                } else {
                    app.trigger('banner:remove', macBanner);
                }
            }
        }
    };
});

